import React, { useEffect, useState, createElement } from 'react';
import { LandingPage } from './pages/LandingPage';
import { SurveyModal } from './components/ui/SurveyModal';
import { SurveyModalContext } from './hooks/use-survey-modal';
export function App() {
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    if (document.getElementById('heatsnap-tracker')) return;
    const script = document.createElement('script');
    script.src = 'https://heatmapsaas-zbdj9rd8.manus.space/tracker.js';
    script.setAttribute('data-token', '1CUa-BlIv5Ucq68xkm42eRp8HxjtJ-dl');
    script.async = true;
    script.id = 'heatsnap-tracker';
    document.body.appendChild(script);
  }, []);
  // Meta Pixel — guard against double-fire
  useEffect(() => {
    if ((window as any).fbq) return;
    !function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    (window as any).fbq('init', '878753891400350');
    (window as any).fbq('track', 'PageView');
  }, []);
  return <SurveyModalContext.Provider value={{
    isOpen,
    open: () => setIsOpen(true),
    close: () => setIsOpen(false)
  }} data-id="element-0">
      <LandingPage data-id="element-1" />
      <SurveyModal data-id="element-2" />
    </SurveyModalContext.Provider>;
}